var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrototype(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.4,
    height: 27,
    viewBox: "0 0 32.4 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-adobe",
    "data-name": "Icon awesome-adobe",
    d: "M22.184,4.5H34.2v27Zm-8.367,0H1.8v27ZM18,14.491,25.559,31.5H20.426l-2.159-5.4H12.734Z",
    transform: "translate(-1.8 -4.5)",
    fill: "#7352ed"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrototype);
export default __webpack_public_path__ + "static/media/prototype.1f2ea5c1c4695efbd768fc4ab1292ab0.svg";
export { ForwardRef as ReactComponent };